import { RootState } from '../../RootState';
import { SessionStateContent } from '../SessionState';
import selectOptionalSessionContent from '@spa/lib/store/session/selectors/selectOptionalSessionContent';

const selectSessionContent = (state: RootState): SessionStateContent => {
  const content = selectOptionalSessionContent(state);
  if (content === null) {
    throw new Error('Session content not initialized');
  }
  return content;
};

export default selectSessionContent;
